import * as React from "react"

const SvgComponent = ({ height = "15px", width = "13px", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 15"
    fill="none"
    {...props}
  >
    <path
      d="M9.667 0h-8C.933 0 .333.6.333 1.333v9.334h1.334V1.333h8V0Zm2 2.667H4.334C3.6 2.667 3 3.267 3 4v9.333c0 .734.6 1.334 1.333 1.334h7.334c.733 0 1.333-.6 1.333-1.334V4c0-.733-.6-1.333-1.333-1.333Z"
      fill="#82DBCF"
    />
  </svg>
)

export default SvgComponent